//import { Route, Router, history } from 'react-router';
import { Link } from 'react-router-dom'
import React, { Component } from 'react'
import { withStore } from '../store'
import CloseUpSVG from '../../svg/CloseUpSVG'
import EditUpSVG from '../../svg/EditUpSVG'
import Table from '../Table'
import Loader from '../Loader'
import { Service } from '../ApiService'
import FixedWrapper from '../FixedWrapper'
import MultiDropDown from '../MultiDropDown/MultiDropDown'
import CheckBox from '../CheckBox'
import SearchInput from '../SearchInput'
import Alert from '../Alert'
import { Helper } from '../Helper'
import MemberEventOrder from './MemberEventOrder'
import { showMessage } from '../alerts'


import TabComponent from '../TabComponent';

class MemberEventOrders extends Component {
    static displayName = MemberEventOrders.name;

    constructor(props) {
        super(props);
        this.state = {
            userId: props.userId,
            openedFromProfile: props.fromProfile,
            userEventId: props.userEventId,
            eventId: props.eventId,
            eventOrders: [],
            loading: false,
            addingOrder: false,
            editingOrder: false,
            orderToEdit: null,
            tempOrders: [],

            showDialog: false,
            showMessage: false
        };
        this.substractHeightElRef = null;
        this.modalWindowRef = null;
        this.membersDropDownRef = null;
        this.removeOrder = this.removeOrder.bind(this);
        this.addOrder = this.addOrder.bind(this);
        this.submitServicesToEvent = this.submitServicesToEvent.bind(this);
    }

    submitServicesToEvent() {
        this.setState({ loading: true });
        var linesToAdd = [];
        this.state.tempServices.map((value) => {
            var serviceLine = this.state.serviceList.find(sl => sl.serviceLineId === value);
            linesToAdd.push({
                servicePriceType: 0,
                price: serviceLine.oneTimePrice,
                calendarEventId: this.state.eventId,
                serviceId: value
            });
        });
        Service.addEventServices(linesToAdd)
            .then(data => {
                console.log(data);
                this.setState({
                    eventServiceLines: data,
                    tempServices: [],
                    loading: false,
                    addingService: false
                })
            });
    }

    editOrder = () => {
        this.setState({ loading: true });
        var modelLine = this.state.orderToEdit;
        let serviceLine = this.state.eventServiceLines.find(x => x.eventServiceLineId === modelLine.eventServiceLineId);
        serviceLine.price = modelLine.price;
        serviceLine.servicePriceType = modelLine.servicePriceType;
        var thenFunc = (data) => this.setState({ loading: false, editingService: false, serviceToEdit: null });
        Service.updateEventService(this.state.eventId, serviceLine)
            .then(thenFunc);
    }

    componentDidMount() {
        this.setState({ loading: true });
        if (this.props.openedFromProfile) {
            Service.getMemberOrders(this.state.userId)
                .then(data => this.setState({ eventOrders: data, loading: false }));
        }
        else {
            Service.getMemberEventOrders(this.state.userEventId)
                .then(data => this.setState({ eventOrders: data, loading: false }));
        }
    }

    addOrder = () => {
        this.setState({
            addingOrder: true
        })
    }

    removeOrder = (service) => {
        var me = this;
        this.setState({ loading: true })
        Service.deleteEventOrder(service.orderId)
            .then(data => {

                if (data.success === false) {
                    this.headerText = 'Error';
                    this.dialogText = 'Failed to remove the Order'
                    this.dialogContent = <h4>{data.message}</h4>
                    this.mode = 'error';
                    this.setState({ showMessage: true, loading: false });

                    return Promise.reject(new Error(data.message));
                }
                else if (data.success === true) {
                    setTimeout(() => {
                        me.setState({ eventOrders: data.data, loading: false });
                    }, 1000);
                }
                else {
                    setTimeout(() => {
                        me.setState({ eventOrders: data, loading: false });
                    }, 1000);
                }

            })
            .catch(err => {
                console.log(err);
            });
    }

    renderOrderNumberColumn = (value, row, index, col) => {
        return (
            <li key={index} className={col.className ? "table-content " + col.className : "table-content"}>
                <span style={{ "flex": "1 1 auto" }} className="big-bold">Order# {row.orderNumber}</span>
                <span style={{ "flex": "1 1 auto" }} >{row.createdDate}</span>
                {this.props.editsPermitted !== false && !row.transactionId &&
                    <button
                        className='round-button small-round-button light-grey-outline-button'
                        style={{ "flex": "0 0 1rem", "marginLeft": "0.2em" }}
                        onClick={() => {
                            this.headerText = 'Warning';
                            this.dialogText = 'You want to remove the Order'
                            this.onOkButtonClick = () => { this.removeOrder(row); this.setState({ showDialog: false }) };
                            this.cancelButtonText = 'Cancel';
                            this.okButtonText = 'Remove';
                            this.dialogContent = <h4>{row.orderNumber}</h4>
                            this.setState({ showDialog: true })/*this.removeMember(row)*/
                        }}
                    >
                        <CloseUpSVG />
                    </button>
                }
                {this.props.editsPermitted !== false && !row.transactionId &&
                    <button
                        className='round-button small-round-button light-grey-outline-button'
                        style={{ "flex": "0 0 1rem", "marginLeft": "0.2em" }}
                        onClick={() => {
                            this.setState({ editingOrder: true, orderToEdit: row })
                        }}
                    >
                        <EditUpSVG />
                    </button>
                    //<Link
                    //    className='round-button small-round-button light-grey-outline-button'
                    //    style={{ "flex": "0 0 1rem", "marginLeft": "0.2em" }}
                    //    to={"/service/" + row.id}
                    //>
                    //    <EditUpSVG />
                    //</Link>
                }
            </li>
        );
    }

    renderAmountColumn = (value, row, index, col) => {
        return (
            <li key={index} className={col.className ? "table-content " + col.className : "table-content"}>
                <div className='input-button-wrapper'>
                    <span>{Helper.CurrencyFormat(row.amount)}</span>
                </div>
                {row.transactionId &&
                    <span style={{ "display": "flex", "flexFlow": "column", "flexWrap": "nowrap", "flex": "1 1 auto" }} className="blue-link">
                    <span style={{ "fontSize": "1.1em", "flex": "1 1 auto" }} onClick={e =>
                        window.location = '/order-checkout/' + row.orderId

                        /*
                         Service.GetPaymentInfo(row.orderId).then(res => {
                            if (res.success) {
                                window.open(res.data.receiptUrl, "_blank");
                            }
                            else {
                                this.headerText = 'Failure';
                                this.dialogText = "Unable to get payment";
                                this.dialogContent = <h4>{res.message}</h4>
                                this.mode = 'error'
                                this.setState({ showMessage: true });
                                return Promise.reject(new Error(res.message));
                            }
                        })
                            .catch(err => {
                                console.log(err);
                            })
                            */
                    }>View payment details</span>
                    </span>
                }
            </li>
        )
    }

    textPropertyRender(element, textProperty) {
        return <div style={{ display: 'flex' }}>
            <div style={{ flex: '1 1 auto' }}>
                <span className='name'>{element["name"]}</span>
                <span className='description-text label-input-wrapper'>{element["description"]}</span>
            </div>
            <div style={{ flex: '0.6 1 auto' }}>
                <span>One time charge: {<strong>{Helper.CurrencyFormat(element["oneTimePrice"])}</strong>}</span>
                <span>Daily charge: {<strong>{Helper.CurrencyFormat(element["dailyPrice"])}</strong>}</span>
            </div>
        </div>
    }

    updateServiceLine = (valueList) => {
        let serviceToEdit = this.state.orderToEdit;
        valueList.forEach(pair => {
            serviceToEdit[pair.property] = pair.value;
        });
        this.setState({ serviceToEdit: serviceToEdit })
    }


    onAddServiceWindowClose() {
        this.setState({ addingService: false })
    }

    getPanelToRender = () => {
        if (this.state.addingOrder) {
            return this.getAddOrderPanel();
        }
        else if (this.state.editingOrder) {
            return this.getEditOrderPanel();
        }
        else {
            return this.getMainEventOrdersPanel()
        }
    }

    getAddOrderPanel = () => {
        const user = this.props.store.userInfo;
        return (
            <MemberEventOrder
                addingService={true}
                eventId={this.state.eventId}
                userEventId={this.state.userEventId}
                editsPermitted={user}
            />
        )
    }

    getEditOrderPanel = () => {
        let serviceToEdit = this.state.orderToEdit;
        const user = this.props.store.userInfo;
        var userEventId = this.state.userEventId;
        if (!userEventId) {
            userEventId = serviceToEdit.userEventid;
        }
        return (
            <MemberEventOrder
                eventId={serviceToEdit.eventId}
                orderId={serviceToEdit.orderId}
                userEventId={userEventId}
                editsPermitted={user}
            />
        )
    }


    renderSimpleValue(value, row, index, col) {
        var cellValue = value;
        if (row.status != 'Draft') {
            cellValue = <strong className={value}>{value}</strong>
        }

        return (
            <li key={index} className={(col.className ? "table-content " + col.className : "table-content")}>{cellValue}</li>
        );
    }

    getMainEventOrdersPanel = () => {
        const eventOrders = this.state.eventOrders;

        const columns = [
            { title: "OrderNumber", accesor: "name", className: "borders-when-display-block", render: this.renderOrderNumberColumn },
            { title: "Amount", accesor: "oneTimePrice", render: this.renderAmountColumn },
            { title: "Status", accesor: "status", className: "small-bold", render: this.renderSimpleValue },
        ];

        return <div>
            {eventOrders.length === 0 && <p className='message-block mb-2 pr-1 pl-1'>There are no orders created for the event.</p>}
            {this.props.editsPermitted !== false && this.props.openedFromProfile != true &&
                <div className="flex-wrap align-center justify-center mb-2 pr-1 pl-1">
                    <button className='big-static-button static-button' onClick={this.addOrder}>CREATE ORDER</button>
                </div>
            }
            {eventOrders.length > 0 && <Table columns={columns} data={eventOrders} className={"break-at-500"} addHeadersForNarrowScreen={true} />}
        </div>
    }

    render() {
        var panel = this.getPanelToRender();
        return (
            <div className='w-100 prpl-0'>
                {this.state.loading && <Loader />}

                {panel}

                {this.state.showDialog && 
                    <Alert 
                        headerText = {this.headerText}
                        text = {this.dialogText}
                        onClose = {() => this.setState({showDialog: false})}
                        showOkCancelButtons = {true}
                        onCancelButtonClick = {() => this.setState({showDialog: false})}
                        onOkButtonClick = {this.onOkButtonClick}
                        cancelButtonText = {this.cancelButtonText}
                        okButtonText = {this.okButtonText}
                        mode = 'warning'
                    >
                       {this.dialogContent}
                    </Alert>
                }

                {this.state.showMessage && showMessage(this.headerText, this.dialogText, this.dialogContent, this.mode, () => this.setState({ showMessage: false }))}
                    {/*<Alert
                        headerText={this.headerText}
                        text={this.dialogText}
                        onClose={() => this.setState({ showMessage: false })}
                        showOkButton={true}
                        onOkButtonClick={() => this.setState({ showMessage: false })}
                        okButtonText="Ok"
                        mode={this.mode}
                    >
                        {this.dialogContent}
                    </Alert>
                }*/}
            </div>
        );
    }
}

export default withStore(MemberEventOrders)



// WEBPACK FOOTER //
// ./src/components/member/MemberEventOrders.jsx